import React from "react";
//#region types
import { NavigationTreeItemProps } from "models/propTypes/navListPropTypes";
//#endregion
//#region components
import { TreeItem } from "@mui/lab";
import NavigationRootItem from "./rootItem";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const NavigationTreeItem: React.FC<NavigationTreeItemProps> = (props) => {
  const { root, node, parentPath, collapsed } = props;

  return !node.hidden ? (
    <TreeItem
      id={node.id}
      key={node.id}
      nodeId={node.id}
      label={
        <NavigationRootItem
          {...node}
          root={root}
          collapsed={collapsed}
          path={parentPath !== undefined ? parentPath.concat(node.path) : node.path}
        />
      }
      classes={{
        root: cssExports.navListTreeItemRoot,
        content: cssExports.navListTreeItem,
        label: cssExports.navListTreeItemContent,
        group: cssExports.navListTreeGroup,
        iconContainer: cssExports.navListTreeIcon,
      }}
    >
      {Array.isArray(node.children)
        ? node.children.map((childNode, index) => (
            <NavigationTreeItem
              key={childNode.id}
              root={false}
              node={childNode}
              parentPath={node.path}
              collapsed={collapsed}
            />
          ))
        : null}
    </TreeItem>
  ) : (
    <></>
  );
};

export default NavigationTreeItem;
